module.exports = __webpack_public_path__ + "static/media/thumb-1.4da427ea.jpg";